import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "@fontsource/montserrat"; // Importa la fuente Montserrat

import Login from "./views/Login/Login";
import SendLink from "./views/Login/SendLink";
import SelectMethod from "./views/Login/SelectMethod";
import ReceiveLink from "./views/Login/ReceiveLink";
import Home from "./views/Home/Home";

import Steps from "./views/Steps/Steps";
import EditUserData from "./views/Account/EditUserData";
import UploadCarnet from "./views/Home/HomeComponents/UploadCarnet";

import InstallationDetail from "./views/Installation/Installation";

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/selectmethod" element={<SelectMethod />} />
        <Route path="/sendlink" element={<SendLink />} />
        <Route path="/receivelink" element={<ReceiveLink />} />
        <Route path="/home" element={<Home />} />
        <Route path="/steps" element={<Steps/>}/>
        <Route path="/upload-carnet" element={<UploadCarnet />} />
        <Route path="/home/installation" element={<InstallationDetail />} />
        <Route path="/edituser" element={<EditUserData />} />
      </Routes>
    </Router>
  );
};

export default App;
